import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import { jsx } from 'react/jsx-runtime';
import * as ToolbarPrimitive from '@radix-ui/react-toolbar';
import clsx from 'clsx';
import { forwardRef } from 'react';
import styles from './toolbar.module.js';
var ToolbarTextToggleItem = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  return jsx(ToolbarPrimitive.ToggleItem, _objectSpread(_objectSpread({}, rest), {}, {
    ref: forwardedRef,
    className: clsx(styles.toolbarItem, styles.toolbarTextToggleItem),
    children: children
  }));
});
export { ToolbarTextToggleItem };